export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_en_US_sappsd.0dce4b939c54cfc4.json"